var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VTooltip',{attrs:{"disabled":!_vm.text || !_vm.enabled},scopedSlots:_vm._u([{key:"popper",fn:function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }